import React, { useState } from "react";
import { Button, Box, Typography } from "@material-ui/core";
import { Edit3 } from "lucide-react";
import UsernameChangeDialog from "./UsernameChangeDialog";
import { validateUsernameChange, User } from "../utils/usernameValidation";

interface UsernameChangeButtonProps {
  user: User;
  onUsernameChanged: (newUsername: string) => void;
  variant?: "button" | "text";
  size?: "small" | "medium" | "large";
}

const UsernameChangeButton: React.FC<UsernameChangeButtonProps> = ({
  user,
  onUsernameChanged,
  variant = "button",
  size = "small",
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const validation = validateUsernameChange(user);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleUsernameChanged = (newUsername: string) => {
    onUsernameChanged(newUsername);
    setDialogOpen(false);
  };

  if (variant === "text") {
    return (
      <Box>
        <Button
          variant="contained"
          color="primary"
          style={{
            cursor: validation.canChange ? "pointer" : "default",
            opacity: validation.canChange ? 1 : 0.6,
            backgroundColor: "#FE5A97", color: "white", fontSize: 16
          }}
          onClick={validation.canChange ? handleOpenDialog : undefined}
          disabled={!validation.canChange}
        >
          Ok
        </Button>
        {/* {!validation.canChange && validation.reason && (
          <Typography variant="caption" color="textSecondary" display="block">
            {validation.reason}
          </Typography>
        )} */}
        <UsernameChangeDialog
          open={dialogOpen}
          onClose={handleCloseDialog}
          user={user}
          onUsernameChanged={handleUsernameChanged}
        />
      </Box>
    );
  }

  return (
    <Box>
      <Button
        variant="outlined"
        size={size}
        startIcon={<Edit3 size={16} />}
        onClick={handleOpenDialog}
        disabled={!validation.canChange}
        style={{
          color: validation.canChange ? "#FE5A97" : "#666",
          borderColor: validation.canChange ? "#FE5A97" : "#666",
        }}
      >
        Change Username
      </Button>

      {!validation.canChange && validation.reason && (
        <Typography
          variant="caption"
          color="textSecondary"
          display="block"
          style={{ marginTop: 4 }}
        >
          {validation.reason}
        </Typography>
      )}

      <UsernameChangeDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        user={user}
        onUsernameChanged={handleUsernameChanged}
      />
    </Box>
  );
};

export default UsernameChangeButton;
